"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var State = /** @class */ (function () {
    function State() {
        this.frame = null;
        this.activeObject = null;
        this.objects = [];
        this.zoomRatio = 1;
        this.contextMenuRequest = null;
        this.editor = null;
    }
    State.prototype.setFrame = function (o) {
        this.frame = o;
    };
    State.prototype.setActiveObject = function (o) {
        this.activeObject = o;
    };
    State.prototype.setObjects = function (o) {
        this.objects = o;
    };
    State.prototype.setZoomRatio = function (o) {
        this.zoomRatio = o;
    };
    State.prototype.setContextMenuRequest = function (o) {
        this.contextMenuRequest = o;
    };
    State.prototype.setEditor = function (o) {
        this.editor = o;
    };
    return State;
}());
exports.default = State;
//# sourceMappingURL=state.js.map